import { render, staticRenderFns } from "./NormalComponent.vue?vue&type=template&id=52a2bcff"
import script from "./NormalComponent.vue?vue&type=script&lang=js"
export * from "./NormalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports